<ng-template #contentNotification let-d="dismiss">
	<div class="modal-body">
		<div class="first-section">
			<img class="" [src]="icon" height="116px" width="116px" *ngIf="icon !== ''">
			<h1 *ngIf="text !== ''">{{text}}</h1>
		</div>
	</div>
</ng-template>